// Public-facing Stimulus controllers only
// Backoffice controllers are in backoffice_index.js

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import CookiesBannerController from "./cookies_banner_controller"
application.register("cookies-banner", CookiesBannerController)

import RiskBannerController from "./risk_banner_controller"
application.register("risk-banner", RiskBannerController)

import SimulatorController from "./simulator_controller"
application.register("simulator", SimulatorController)

import ScpiFilterController from "./scpi_filter_controller"
application.register("scpi-filter", ScpiFilterController)

import LeadModalController from "./lead_modal_controller"
application.register("lead-modal", LeadModalController)


import TocController from "./toc_controller"
application.register("toc", TocController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ScpiGridController from "./scpi_grid_controller"
application.register("scpi-grid", ScpiGridController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import SimulatorTabsController from "./simulator_tabs_controller"
application.register("simulator-tabs", SimulatorTabsController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import DownloadZipController from "./download_zip_controller"
application.register("download-zip", DownloadZipController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import RateTooltipController from "./rate_tooltip_controller"
application.register("rate-tooltip", RateTooltipController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import BookingWidgetController from "./booking_widget_controller"
application.register("booking-widget", BookingWidgetController)

import ContactTabsController from "./contact_tabs_controller"
application.register("contact-tabs", ContactTabsController)


import GoogleTagManagerController from "./google_tag_manager_controller"
application.register("google-tag-manager", GoogleTagManagerController)

import ExpandableSectionController from "./expandable_section_controller"
application.register("expandable-section", ExpandableSectionController)

import AiSearchBarController from "./ai_search_bar_controller"
application.register("ai-search-bar", AiSearchBarController)

import AiBottomBarController from "./ai_bottom_bar_controller"
application.register("ai-bottom-bar", AiBottomBarController)

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AiHistoryController from "./ai_history_controller"
application.register("ai-history", AiHistoryController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)
